import { Box, Button, Card, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API } from 'src/common/config/API';
import {
  decryptEncryptedJWT,
  getAuthenticated,
  getCookie,
  handleInterComClick,
  isAiAddonLocked,
  localStorageMethod
} from 'src/common/config/FunctionHelper';
import {
  localSeoConnectTexts,
  localSeoLogo,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow,
  logoWithoutBackground,
  paths,
  SEOSpaceLocal,
  squareSpaceConnectTexts,
  squareSpaceUtm,
  squareSpaceUtmAPIExt,
  squareSpaceUtmLocalSeo,
  squareSpaceUtmOnBoardingAPIExt
} from 'src/common/config/TextMessage';
import {
  getPlanNameFromCookie,
  hasLocalSeoCookie,
  removeUtmCookie,
  setUtmCookie,
  updateSearchesDetailsAndLimits
} from 'src/common/config/FunctionHelperPartTwo';
import { SquareSpaceConnectSx } from 'src/common/CommomSxs';
import OnBoardingNavbar from 'src/common/OnBoardingNavbar';
import {
  getCreditDetails,
  marketPlaceUsersCount,
  squareOrderToken
} from 'src/common/Scraper';
import { RootState } from 'src/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setIsOpenChangePlan } from 'src/redux/siteAuditReducer';
/**
 * SquareSpace authentication component.
 */
const SquareSpaceAuthConnect = () => {
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState('');
  const [showLocalSeoMessage, setShowLocalSeoMessage] = useState(false);
  const [error, setError] = useState<string>('');
  const [accessDeniedError, setAccessDeniedError] = useState<string>('');
  const navigationLocation = useLocation();
  const navigator = useNavigate();
  const params = new URLSearchParams(navigationLocation.search);
  const utmParam = params.get('utm');
  const viaParam = params.get('via');
  const webSiteIdParam = params.get('website_id');
  const UtmOnBoardingLocal = localStorageMethod('get', 'is_utm_onboarding');
  const userDetails: any = useSelector(
    (state: RootState) => state?.counter?.userDetails
  );
  const isCorrectParam =
    viaParam == squareSpaceConnectTexts?.utmValue ||
    viaParam == squareSpaceConnectTexts?.utmOnBoardingValue;
  const isLocalSeoParam = viaParam == squareSpaceConnectTexts?.localseo;
  const isSignUp = localStorageMethod('get', 'isSignUpLocalSeo');
  if (viaParam) {
    if (isCorrectParam) {
      if (viaParam == squareSpaceConnectTexts?.utmOnBoardingValue) {
        localStorageMethod('set', 'is_utm_onboarding', 'true');
      }
      setUtmCookie(squareSpaceUtm, viaParam);
      removeUtmCookie(localseoSignupSqspFlow);
    }
    if (isLocalSeoParam) {
      setUtmCookie(localseoSignupSqspFlow, localSeoSignupSourceSqsp);
      removeUtmCookie(squareSpaceUtm);
    }
  }
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  let isFreePlan = activePlanName == planDetails?.free;
  let searchesDetails: any =
    useSelector((state: RootState) => state.keywordResearch.searchesDetails) ??
    null;
  const isNotUnlocked = isAiAddonLocked();
  let selectedSiteSqSp = localStorageMethod('get', 'squareSpaceSite');
  let getFreeOnboarding = localStorageMethod('get', 'free_onboarding') || null;
  let isFreeOnBoarding = getFreeOnboarding == 'true';
  const isAuthenticated: any = getAuthenticated();
  const getLocalSeoCookie = getCookie(localseoSignupSqspFlow) ?? null;
  const isLocalSeo = getLocalSeoCookie === localSeoSignupSourceSqsp;
  const isLocalSeoSession = hasLocalSeoCookie();
  const planName = getPlanNameFromCookie();
  const isFreePlanDetected = planName === planDetails?.free;
  let utm = getCookie(squareSpaceUtm);
  const dispatch = useDispatch();

  // After SquareSpace set value in text box and store token
  useEffect(() => {
    if (isFreePlanDetected && isLocalSeo) {
      dispatch(setIsOpenChangePlan(true));
      navigator(paths?.billing);
      return;
    }
    // if (!utm) {
    // if (isCorrectParam) {
    if (!isLocalSeo || utm) {
      handleMarketPlaceUsersCount();
    }
    // }
    // When page load
    const queryParams = new URLSearchParams(navigationLocation.search);
    // Access specific query parameters
    const codeParam = queryParams.get('code');
    const accessDeniedError = queryParams.get('error');
    // Check if user in come to signin or not
    if (codeParam) {
      let requestPayLoad = {
        code: codeParam,
        utm: 'squarespace_market'
      };

      // Start store token value
      setLoading(true);
      if (isLocalSeo && !utm) {
        localSeoToken(requestPayLoad);
      } else {
        API.squareProductToken(
          API.EndPoint.squareProductToken,
          API.Method.post,
          undefined,
          requestPayLoad,
          (response) => {
            if (response.status == 200) {
              const responseDetails = { ...response.data };

              if (responseDetails?.status == 'success') {
                setSuccessMessage(responseDetails.message);
                localStorageMethod(
                  'set',
                  'squareSpaceSite',
                  responseDetails?.response?.url
                );
                localStorageMethod(
                  'set',
                  'squareSpaceSiteId',
                  responseDetails?.response?.siteId
                );
                localStorageMethod(
                  'set',
                  'squareSpaceAccountId',
                  responseDetails?.response?.accountId
                );


              } else {
                setError(responseDetails?.message);
                removeUtmCookie(squareSpaceUtm); // Remove cookies

              }
            } else {
              setError(
                response?.message || 'Something went wrong, Please try again'
              );
              removeUtmCookie(squareSpaceUtm); // Remove cookies
            }
            setLoading(false);
          }
        );
      }
    }
    // when user clicks cancel, then show the error
    if (accessDeniedError) {
      setLoading(false);
      setAccessDeniedError(squareSpaceConnectTexts?.accessDenied);
    }

    if (!codeParam && !accessDeniedError) {
      if (viaParam) {
        if (isAuthenticated == 'true') {
          squareSpaceAuth();
        } else {
          localStorageMethod('set', 'is_from_utm_signup', 'true');
          navigator(isLocalSeo ? paths?.signupLocalSeoExt : paths?.signup);
        }
      } else {
        squareSpaceAuth();
      }
    }
    // }
  }, []);

  const handleMarketPlaceUsersCount = async () => {
    let jwtDecode: any;
    if (isAuthenticated == 'true') {
      const encodedJWT = getCookie(process.env.REACT_APP_COOKIE_NAME);

      const jwtDecode: any = await decryptEncryptedJWT(encodedJWT);

      if (jwtDecode) {
        jwtDecode.userId = jwtDecode?.userId;
      }
    }
    const payload = {
      userId: jwtDecode?.userId ? jwtDecode?.userId : null,
      webSiteId: webSiteIdParam ? webSiteIdParam : null,
      isOnboarding: UtmOnBoardingLocal == 'true'
    };
    await marketPlaceUsersCount(payload);
  };

  const localSeoToken = async (payload) => {
    const response: any = await squareOrderToken(payload);
    if (response?.status == 'success') {
      setLoading(true);
      setShowLocalSeoMessage(true);
      const responseDetails = response;
      removeUtmCookie(squareSpaceUtm); // Remove cookies
      if (responseDetails?.status == 'success') {
        localStorageMethod(
          'set',
          'squareSpaceSite',
          responseDetails?.response?.url
        );
        localStorageMethod(
          'set',
          'squareSpaceSiteId',
          responseDetails?.response?.siteId
        );
        localStorageMethod(
          'set',
          'squareSpaceAccountId',
          responseDetails?.response?.accountId
        );
        localStorageMethod(
          'set',
          'squareSpaceAccountName',
          responseDetails?.response?.siteTitle
        );


      } else {
        setError(responseDetails?.message);
        setLoading(false);
        setShowLocalSeoMessage(false);
        localStorageMethod('remove', 'isSignUpLocalSeo');

      }
    } else {
      setError(response?.message || 'Something went wrong, Please try again');
      setLoading(false);
      setShowLocalSeoMessage(false);
      localStorageMethod('remove', 'isSignUpLocalSeo');
    }
    setTimeout(() => {
      if (response?.status == 'success') {
        setSuccessMessage(response?.message);
      } else {
        setLoading(false);
        localStorageMethod('remove', 'isSignUpLocalSeo');
        setShowLocalSeoMessage(false);
      }
    }, 5000);
  };

  // Redirect to the squareSpaceAuth screen
  const squareSpaceAuth = () => {
    const endPointExtension = isLocalSeo
      ? squareSpaceUtmLocalSeo
      : UtmOnBoardingLocal == 'true'
      ? squareSpaceUtmOnBoardingAPIExt
      : squareSpaceUtmAPIExt;
    const updatedEndpointExt =
      viaParam == squareSpaceConnectTexts?.utmValue
        ? squareSpaceUtmAPIExt
        : viaParam == squareSpaceConnectTexts?.utmOnBoardingValue
        ? squareSpaceUtmOnBoardingAPIExt
        : endPointExtension;
    API.squareAuth(
      // API.EndPoint.squareAuth + '?utm=squarespace_market',
      API.EndPoint.squareAuth + updatedEndpointExt,
      API.Method.get,
      undefined,
      {},
      (response) => {
        location.href = response?.data?.authUrl;
        setAccessDeniedError('');
      }
    );
  };

  const handleSuccess = async () => {
    // Open blank tab immediately to bypass popup blockers
    setSuccessMessage('');

    // navigator(paths?.signup);
    if (isFreePlan) {
      if (isLocalSeo) {
        dispatch(setIsOpenChangePlan(true));
        navigator(paths?.billing);
      } else {
        if (!searchesDetails?.totalAiSlots) {
          await getSearchesDetail();
        }
        navigator(
          isFreeOnBoarding
            ? paths?.onBoarding
            : isNotUnlocked
            ? paths?.externalScans
            : paths?.onBoarding
        );
      }
    } else {
      if (isLocalSeo) {
        localStorageMethod('set', 'is_local_seo_sqsp_flow', 'true');
        localStorageMethod('set', 'is_local_seo_sqsp_site_selected', 'true');
        localStorageMethod(
          'set',
          'is_show_connection_for_local_seo_sqsp_site',
          'true'
        );
        navigator(utm ? paths?.trySeoSpace : paths?.localChecker);
        removeUtmCookie(squareSpaceUtm); // Remove cookies
        if (utm) {
          clearLocalSeoCookiesForUtm();
        }
      } else {
        navigator(isLocalSeoSession ? paths?.trySeoSpace : paths?.onBoarding);
        if (utm && isLocalSeoSession) {
          clearLocalSeoCookiesForUtm();
        }
      }
    }
    setLoading(false);
    setShowLocalSeoMessage(false);
    localStorageMethod('remove', 'isSignUpLocalSeo');
  };

  const clearLocalSeoCookiesForUtm = () => {
    localStorageMethod('remove', 'squareSpaceSite');
    localStorageMethod('remove', 'squareSpaceSiteId');
    localStorageMethod('remove', 'squareSpaceAccountId');
    localStorageMethod('remove', 'is_show_connection_for_local_seo_sqsp_site');
    removeUtmCookie(squareSpaceUtm);
    removeUtmCookie(localseoSignupSqspFlow);
  };

  useEffect(() => {
    if (successMessage) {
      handleSuccess();
    }
  }, [successMessage]);

  const getHostname = (url) => {
    if (!url) return null;

    let hostname = url?.replace(/^https?:\/\//, '');
    hostname = hostname?.replace(/^www\./, '');

    return hostname;
  };

  const getSearchesDetail = async () => {
    const response: any = await getCreditDetails();
    if (response) {
      updateSearchesDetailsAndLimits(response);
    }
  };

  return (
    <>
      <OnBoardingNavbar />
      <div
        className="flex justify-center align-middle"
        style={SquareSpaceConnectSx?.mainContainer}
      >
        <div className="flex items-center justify-center relative h-full w-full">

          <div className="absolute">
            <Card
              className="px-10 py-14 md:px-15 md:py-16 mx-5"
              sx={SquareSpaceConnectSx?.cardSx}
            >
              <Box>
                <Box className="flex flex-col justify-center items-center ">
                  <Box className="mb-6 flex justify-center">
                    <img
                      src={isLocalSeo ? localSeoLogo : logoWithoutBackground}
                      loading="lazy"
                      width={'150px'}
                    />
                  </Box>
                  {showLocalSeoMessage && (
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        `/static/images/icons/onBoardingGroup.png`
                      }
                      alt="icon"
                      loading="lazy"
                    />
                  )}
                  {(accessDeniedError || error) && (
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        `/static/images/icons/onBoardingError.png`
                      }
                      alt="icon"
                      loading="lazy"
                    />
                  )}

                  {(accessDeniedError || error) && (
                    <Box sx={SquareSpaceConnectSx?.accountFailedBox}>
                      <Typography sx={SquareSpaceConnectSx?.accountFailedTypo}>
                        {'Connection Failed'}
                      </Typography>
                    </Box>
                  )}

                  {(accessDeniedError || error) && (
                    <>
                      {isLocalSeo ? (
                        <>
                          <Typography
                            sx={SquareSpaceConnectSx?.successDescTypo}
                          >
                            {`Something went wrong while trying to connect. Please try again, or check that you're logged into the right Squarespace account.`}
                          </Typography>
                          <Typography
                            sx={{
                              ...SquareSpaceConnectSx?.failDescTypo
                            }}
                          >
                            {'If the issue continues, '}{' '}
                            <span
                              style={{
                                color: 'var(--color-primary)',
                                fontWeight: 500,
                                textDecoration: 'underline',
                                textDecorationThickness: '1.2px',
                                cursor: 'pointer',
                                textUnderlineOffset: '4px'
                              }}
                              onClick={handleInterComClick}
                            >
                              contact support
                            </span>{' '}
                          </Typography>
                        </>
                      ) : (
                        <Typography sx={SquareSpaceConnectSx?.successDescTypo}>
                          {`Please allow ${
                            isLocalSeo ? SEOSpaceLocal : 'SEOSpace'
                          } to connect to Squarespace in order to continue, or contact support.`}
                        </Typography>
                      )}
                    </>
                  )}

                  {(accessDeniedError || error) && (
                    <Button
                      variant="contained"
                      fullWidth
                      sx={SquareSpaceConnectSx?.successBtn}
                      onClick={() => {
                        setError('');
                        setLoading(false);
                        squareSpaceAuth();
                      }}
                    >
                      {'Back'}
                    </Button>
                  )}
                  {loading && !showLocalSeoMessage && (
                    <Box>
                      <CircularProgress size={24} />
                    </Box>
                  )}
                  {showLocalSeoMessage && (
                    <>
                      {isSignUp == 'true' && (
                        <Typography
                          sx={SquareSpaceConnectSx?.successMessageTypo}
                        >
                          {localSeoConnectTexts?.thankYoumessage}
                        </Typography>
                      )}
                      <Typography sx={SquareSpaceConnectSx?.successDescTypo}>
                        {localSeoConnectTexts?.connectSuccessMessage}
                      </Typography>
                    </>
                  )}

                </Box>
              </Box>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default SquareSpaceAuthConnect;
